
import React from "react";

import { PaymentFailure } from "components/Payment/PaymentFailurePage";

const PaymentFailurePage = () => {
  return <PaymentFailure />;
};
export default PaymentFailurePage;